export default {
	setLanguage({ commit }, language) {
		commit('setLanguage', language)
	},
}
